// @ts-strict-ignore
/* eslint-disable camelcase */
/** @jsx jsx */
import { jsx } from 'theme-ui'
import React, { Fragment } from 'react'

import { Modal } from '@uswitch/spark'
import { ButtonLink } from '@uswitch/ev-components/lib/components/elements/button-link'

const ResultExpired = () => (
  <Fragment>
    <h3 sx={{ variant: 'compounds.expired-modal.heading' }}>Your results are no longer accurate</h3>
    <p sx={{ variant: 'compounds.expired-modal.text' }}>Results are only valid for 24 hours.</p>
    <p sx={{ variant: 'compounds.expired-modal.text' }}>
      To get more accurate results, you can run a new eligibility check.
    </p>
  </Fragment>
)

const ProviderTimeout = () => (
  <Fragment>
    <h3 sx={{ variant: 'compounds.expired-modal.heading' }}>Eligibility provider timed out</h3>
    <p sx={{ variant: 'compounds.expired-modal.text' }}>You can refresh the page to get results</p>
    <p sx={{ variant: 'compounds.expired-modal.text' }}>
      To get fresher results, you can run a new eligibility check.
    </p>
  </Fragment>
)

interface ProductTableModalProps {
  eligibilityProviderTimeout: any
}

export const ProductTableModal: React.FC<ProductTableModalProps> = ({
  eligibilityProviderTimeout,
}) => (
  <Modal>
    <div
      sx={{
        paddingX: '20px',
        paddingY: '25px',
        textAlign: ['center', 'left'],
      }}
    >
      <Choose>
        <When condition={eligibilityProviderTimeout}>
          <ProviderTimeout />
        </When>
        <Otherwise>
          <ResultExpired />
        </Otherwise>
      </Choose>
      <div
        sx={{
          textAlign: ['center', 'right'],
        }}
      >
        <div sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ButtonLink
            sx={{
              width: 'button.width',
              marginRight: 'md',
              paddingY: ['13', 'base'],
              textDecoration: 'none',
              border: '1px solid',
              borderColor: 'primary',
            }}
            href='/credit-cards'
            variant='link'
            size='small'
          >
            Back to credit cards
          </ButtonLink>
          <ButtonLink
            sx={{ paddingY: ['13', 'base'] }}
            href='/credit-cards/eligibility-checker'
            variant='primary'
            size='small'
          >
            Check eligibility
          </ButtonLink>
        </div>
      </div>
    </div>
  </Modal>
)
